import gql from "graphql-tag";

export const GET_CREATOR_PROFILE_INFO = gql`
    query getCreatorProfileInfo($username: String!) {
        info: creatorProfileDetailByUsername(username: $username) {
            id
            name
            username
            description
            city
            country
            website
            avatarUrl(size: 260)
            twitter
            facebook
            behance
            dribbble
            linkedin
            instagram
        }
    }
`;
